import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=48ab7816&scoped=true"
import script from "./operate.vue?vue&type=script&lang=js"
export * from "./operate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab7816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ab7816')) {
      api.createRecord('48ab7816', component.options)
    } else {
      api.reload('48ab7816', component.options)
    }
    module.hot.accept("./operate.vue?vue&type=template&id=48ab7816&scoped=true", function () {
      api.rerender('48ab7816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign/weekly/operate.vue"
export default component.exports